import { createAction } from 'typesafe-actions';
import { DocumentsCurrentId, DocumentsOptions } from './types';

export const INIT_DOCUMENTS = 'documents/INIT_DOCUMENTS';

export const UPDATE_DOCUMENTS = 'documents/UPDATE_DOCUMENTS';

export const INIT_DOCUMENTS_CURRENT_ID = 'documents/INIT_DOCUMENTS_CURRENT_ID';

export const UPDATE_DOCUMENTS_CURRENT_ID =
  'documents/UPDATE_DOCUMENTS_CURRENT_ID';

export const UPDATE_DOCUMENTS_OPTIONS = 'documents/UPDATE_DOCUMENTS_OPTIONS';

export const initDocuments = createAction(INIT_DOCUMENTS)();

export const initDocumentsCurrentId = createAction(INIT_DOCUMENTS_CURRENT_ID)();

export const updateDocumentsCurrentId = createAction(
  UPDATE_DOCUMENTS_CURRENT_ID
)<DocumentsCurrentId>();

export const updateDocumentsOptions = createAction(UPDATE_DOCUMENTS_OPTIONS)<
  DocumentsOptions
>();
